import { InternalDatabaseService } from '@stockcare-storage/internal/internal-database.service';
import { BasketStaging } from './basketStaging';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BasketStagingStorageService {
  readonly table: string;
  readonly patientIdIndex: string;
  readonly clientIdIndex: string;

  constructor(private internalDatabaseService: InternalDatabaseService) {
    const table = BasketStaging.getTableDefinition();
    this.table = table.TableName;
    this.patientIdIndex = table.Indexes[0].Name;
    this.clientIdIndex = table.Indexes[1].Name;
  }
  async addBasket(basket: BasketStaging): Promise<void> {
    await this.internalDatabaseService.add<BasketStaging>(this.table, basket);
  }

  async updateBasket(basket: BasketStaging): Promise<void> {
    await this.internalDatabaseService.update<BasketStaging>(this.table, basket);
  }

  async getClientBasket(clientId: string): Promise<BasketStaging> {
    return await this.internalDatabaseService.getByIndex<BasketStaging>(this.table, this.clientIdIndex, clientId);
  }

  async getPatientBaskets(patientId: string): Promise<BasketStaging[]> {
    return await this.internalDatabaseService.getByIndex<BasketStaging[]>(this.table, this.patientIdIndex, patientId);
  }

  async getStagedBaskets(): Promise<BasketStaging[]> {
    return await this.internalDatabaseService.getAll<BasketStaging>(this.table);
  }

  async deleteStagedBasket(basket: BasketStaging) {
    return await this.internalDatabaseService.delete(this.table, basket.Id);
  }
}
